<template>
  <footer class="flex justify-between gap-4 w-full">
    <CButton @click="emit('cancel')">
      {{ t('canvasUI.common.cancel') }}
    </CButton>

    <CButton :loading="isLoading" type="primary" @click="emit('close')">
      {{ t('canvasUI.common.done') }}
    </CButton>
  </footer>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import CButton from '@lib/components/CButton/CButton.vue'

defineProps<{
  isLoading: boolean
}>()

const emit = defineEmits<{
  close: []
  cancel: []
}>()

const { t } = useI18n()
</script>
